import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StepPreconditionService } from '../services/step-precondition.service';

/**
 * Route guard for the Plan step (step 2).
 *
 * Only allows access if zipcode exists in session storage.
 * Otherwise redirects to fallback route determined by current data state.
 */
export const planGuard: CanActivateFn = () => {
  const stepPrecondition = inject(StepPreconditionService);
  const router = inject(Router);

  if (stepPrecondition.canAccessPlan()) {
    return true;
  }

  // Return UrlTree for redirect instead of side-effect navigation
  const fallbackRoute = stepPrecondition.getFallbackRoute();
  return router.createUrlTree([fallbackRoute]);
};
